import Grid from "@mui/material/Unstable_Grid2";
import './legal.css';

const PrivacyPage = () => {
    return (
        <Grid container spacing={2} sx={{ml: 2, mt: 5, mr: 2, mb: 2}}>
            <Grid>
                <h1>Privacy Policy</h1>

                <section>
                    <h2>1. Introduction</h2>
                    <p>This Privacy Policy explains how Nasbai collects, uses, and protects your personal data in
                        accordance with the General Data Protection Regulation (GDPR).</p>
                </section>

                <section>
                    <h2>2. Data Controller</h2>
                    <p>The data controller for your personal data is:</p>
                    <p>Silvio Ciavarrella<br/>Alter Schulhof 2<br/>89597 Munderkingen<br/>Germany<br/>Email:
                        support&#64;nasbai.com</p>
                </section>

                <section>
                    <h2>3. Data We Collect and Our Legal Basis for Processing</h2>
                    <p>We collect and process the following categories of data for the purposes and on the legal bases
                        outlined below:</p>
                    <ul>
                        <li>
                            <strong>Registration Data:</strong>
                            <ul>
                                <li><strong>Data Collected:</strong> Email address, username, and password (hashed).
                                </li>
                                <li><strong>Purpose:</strong> To create and manage your user account, authenticate your
                                    access to our services, and enable communication regarding service-related matters.
                                </li>
                                <li><strong>Legal Basis:</strong> Necessary for the performance of a contract with you
                                    (Art. 6(1)(b) GDPR) to provide our core services.
                                </li>
                                <li><strong>Retention:</strong> We retain this data for the duration of your active
                                    account. If your account is deleted, we may retain basic information for a limited
                                    period (e.g., 6 months) to fulfill legal obligations or resolve disputes.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Profile Data:</strong>
                            <ul>
                                <li><strong>Data Collected:</strong> Bio, social media links (e.g., links to Instagram,
                                    Twitter, etc., if you choose to provide them).
                                </li>
                                <li><strong>Purpose:</strong> To create and personalize your public user profile on
                                    Nasbai, allowing other users to learn more about you and connect with your other
                                    online presences.
                                </li>
                                <li><strong>Legal Basis:</strong> Necessary for the performance of a contract with you
                                    (Art. 6(1)(b) GDPR) to provide the profile functionality. Your provision of this
                                    data is voluntary, and you can edit or remove it at any time.
                                </li>
                                <li><strong>Retention:</strong> Retained for the duration of your active account.</li>
                            </ul>
                        </li>
                        <li>
                            <strong>Uploaded Audio Data (User Content):</strong>
                            <ul>
                                <li><strong>Data Collected:</strong> Audio files you upload to the Nasbai platform,
                                    including metadata you provide (e.g., track titles, descriptions).
                                </li>
                                <li><strong>Purpose:</strong> To host, store, and make available your audio content on
                                    the Nasbai platform as per your instructions, enabling other users to access and
                                    listen to it.
                                </li>
                                <li><strong>Legal Basis:</strong> Necessary for the performance of a contract with you
                                    (Art. 6(1)(b) GDPR) to provide the content hosting and sharing functionalities of
                                    our service.
                                </li>
                                <li><strong>Retention:</strong> Retained for the duration of your active account, unless
                                    you delete the specific audio file.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Premium Subscription & Payment Data:</strong>
                            <ul>
                                <li>
                                    <strong>Data Collected:</strong> Transaction details (amount, currency, timestamp),
                                    payment method (e.g., credit card, SEPA), status, and anonymized payment
                                    identifiers.
                                </li>
                                <li>
                                    <strong>Purpose:</strong> To process premium subscriptions and one-time payments
                                    securely.
                                </li>
                                <li>
                                    <strong>Processor:</strong> We use <a href="https://www.mollie.com/en/privacy"
                                                                          target="_blank" rel="noopener noreferrer">Mollie
                                    B.V.</a>, a regulated payment service provider based in the Netherlands.
                                </li>
                                <li>
                                    <strong>Legal Basis:</strong> Performance of a contract (Art. 6(1)(b) GDPR) and
                                    compliance with financial regulations (Art. 6(1)(c) GDPR).
                                </li>
                                <li>
                                    <strong>Retention:</strong> Financial records and transaction metadata are stored
                                    for <strong>10 years</strong> in accordance with § 147 AO (German tax law).
                                </li>
                                <li>
                                    <strong>Note:</strong> Mollie processes your payment data as an independent
                                    controller under its own legal obligations (e.g., fraud prevention, AML).
                                </li>
                            </ul>

                        </li>
                        <li>
                            <strong>Usage Data:</strong>
                            <ul>
                                <li><strong>Data Collected:</strong> IP address, browser type, pages visited, session
                                    duration (via server logs).
                                </li>
                                <li><strong>Purpose:</strong> To ensure the security and stability of our services,
                                    diagnose technical issues, prevent fraudulent activity, analyze service performance
                                    to improve user experience, and to determine applicable tax rates based on your IP
                                    address.
                                </li>
                                <li><strong>Legal Basis:</strong> Our legitimate interests in maintaining and improving
                                    our services, ensuring network and information security, and complying with tax
                                    regulations (Art. 6(1)(f) GDPR).
                                </li>
                                <li><strong>Retention:</strong> Typically retained for up to 12 months for security and
                                    analytical purposes.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Country Data:</strong>
                            <ul>
                                <li><strong>Data Collected:</strong> Country of the user.</li>
                                <li><strong>Purpose:</strong> To determine and apply the correct tax rates for your
                                    purchases in accordance with legal obligations.
                                </li>
                                <li><strong>Legal Basis:</strong> Necessary for compliance with a legal obligation (Art.
                                    6(1)(c) GDPR) related to tax laws.
                                </li>
                                <li><strong>Retention:</strong> Retained for 10 years under German tax law.</li>
                            </ul>
                        </li>
                        <li>
                            <strong>Cookies and Local Storage:</strong>
                            <ul>
                                <li><strong>Data Collected:</strong> We use essential cookies (e.g., for authentication
                                    and session management) and may utilize your browser's local storage to temporarily
                                    store data strictly necessary for providing the service (e.g., for essential user
                                    session data).
                                </li>
                                <li><strong>Purpose:</strong> These technologies are necessary to maintain your login
                                    session, ensure secure and personalized use of our services, and enable core
                                    functionalities.
                                </li>
                                <li><strong>Legal Basis:</strong> Necessary for the performance of a contract with you
                                    (Art. 6(1)(b) GDPR) to enable your use of our services.
                                </li>
                                <li><strong>Retention:</strong> Essential cookies are session-based or linked to token
                                    expiration. Data stored in local storage is retained for the duration required to
                                    fulfill its specific purpose (e.g., for the duration of your logged-in session for
                                    technical functionality) and may persist across browser sessions until explicitly
                                    cleared by the user or the application.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>4. Data Sharing</h2>
                    <p>Your personal data will not be shared with third parties, except:</p>
                    <ul>
                        <li>
                            With service providers under strict data processing agreements (e.g., hosting providers,
                            email service providers).
                        </li>
                        <li>
                            With our payment processor: We use <a href="https://www.mollie.com/en/privacy"
                                                                  target="_blank" rel="noopener noreferrer">Mollie
                            B.V.</a>, a licensed payment service provider based in the Netherlands. Mollie processes
                            only the data necessary to complete payment transactions and acts as an independent data
                            controller under applicable financial and anti-fraud regulations.
                        </li>
                        <li>
                            When required by law or governmental authorities.
                        </li>
                    </ul>
                    <p>We do not sell or rent your personal data to anyone. We ensure that all third-party service
                        providers are compliant with GDPR and process data only on our documented instructions, where
                        applicable.</p>
                </section>


                <section>
                    <h2>5. International Transfers</h2>
                    <p>Your data is stored within the European Union. If data is transferred outside the EU/EEA (e.g.,
                        to
                        service providers like Ko-fi, whose operations may involve transfers to countries such as the
                        UK), we
                        ensure an adequate level of protection through appropriate safeguards such as standard
                        contractual clauses (SCCs) approved by the European Commission, or reliance on adequacy
                        decisions by the European Commission, where applicable.</p>
                </section>

                <section>
                    <h2>6. Your Rights</h2>
                    <p>You have the following rights under the GDPR:</p>
                    <ul>
                        <li>Right to access your data (Art. 15 GDPR).</li>
                        <li>Right to rectification (Art. 16 GDPR).</li>
                        <li>Right to erasure ("right to be forgotten") (Art. 17 GDPR).</li>
                        <li>Right to restriction of processing (Art. 18 GDPR).</li>
                        <li>Right to data portability (Art. 20 GDPR).</li>
                        <li>Right to object (Art. 21 GDPR).</li>
                        <li>Right to withdraw consent at any time (Art. 7(3) GDPR).</li>
                        <li>Right to lodge a complaint with a supervisory authority (Art. 77 GDPR).</li>
                    </ul>
                </section>

                <section>
                    <h2>7. Data Security</h2>
                    <p>We use SSL encryption, strict access controls, and regular audits to protect your data from
                        unauthorized access, alteration, or loss.</p>
                </section>

                <section>
                    <h2>8. Changes to this Privacy Policy</h2>
                    <p>We reserve the right to modify this Privacy Policy at any time. We will notify you of any
                        significant changes by email or through a prominent notice on our website. Your continued use of
                        the service after such changes have been made constitutes your acceptance of the revised Privacy
                        Policy.</p>
                </section>

                <section>
                    <h2>9. Contact</h2>
                    <p>For any privacy-related inquiries or requests, contact us at:</p>
                    <p>Email: support&#64;nasbai.com</p>
                </section>
            </Grid>
        </Grid>

    );
}

export default PrivacyPage;